




import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'InvoiceStatus',
  props: {
    status: {
      type: String,
      default: '',
    },
  },
  computed: {
    color(): string {
      if (this.status === 'unpaid') return 'red'
      if (this.status === 'paid') return 'green'

      return 'orange'
    },
  },
})
